class RiskFactorAndTreatment {
    public PretermLabourPlan: string;
    public PretermLabourOther: string;
    public RestrictedIntrauterineGrowthPlan: string;
    public RestrictedIntrauterineGrowthOther: string;
    public HypertensionPlan: string;
    public DiabetesPlan: string;
    public MaternalAgePlan: string;
    public CongenitalAnormaliesPlan: string;
    public PresenceOfSexuallyTransmittedBloodBorneInfectionPlan: string;
    public PregnancyAfterInVitroFertilizationPlan: string;
    public VaginalBirthAfterCesareanPlan: string;

    constructor(fields?: Partial<RiskFactorAndTreatment>) {
        Object.assign(this, fields);
    }
}

export { RiskFactorAndTreatment };
